"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
/**
 * 移动方式, 不传默认 0
 */
var ActionType;
(function (ActionType) {
    ActionType[ActionType["DRAG"] = 0] = "DRAG";
    ActionType[ActionType["LEFT"] = 1] = "LEFT";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
